// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { infoTileStyles } from "@rpsc/App/Widgets/InfoTile/InfoTile";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { linkArrowStyle, mergeWithCss } from "@rpsc/XDL/Utilities";
import color from "@rpsc/XDL/Utilities/color";
import { css } from "styled-components";

infoTileStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        border: 1px solid ${color("common.border")};
        background-color: ${color("common.white")};
        border-radius: 2px;
        height: 100%;
        padding: 12px;
    `,
};

infoTileStyles.imageWrapperStyles = {
    css: css`
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

infoTileStyles.image = {
    css: css`
        max-width: 100%;
        max-height: 100%;
    `,
};

infoTileStyles.heading = {
    css: css`
        ${TypographyStyle} {
            line-height: 22px;
            font-size: 16px;
            font-weight: ${fontConfig.weight.bold};
            margin: 0;
            color: ${color("common.black")};
        }
    `,
};
infoTileStyles.headingWrapper = {
    css: css`
        display: flex;
        gap: 12px;
        align-items: center;
        margin-bottom: 12px;
    `,
};
infoTileStyles.subHeading = {
    css: css`
        ${TypographyStyle} {
            line-height: 17px;
            font-size: 12px;
            font-weight: ${fontConfig.weight.regular};
            margin: 0;
        }
    `,
};
infoTileStyles.content = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    `,
};

infoTileStyles.infoCardLink = {
    ...mergeWithCss(linkArrowStyle, {
        typographyProps: {
            size: 12,
            css: css`
                line-height: 17px;
            `,
        },
        icon: {
            iconProps: {
                size: 12,
            },
        },

        css: css`
            align-self: flex-start;
        `,
    }),
};

infoTileStyles.textWrapperStyles = {
    css: css`
        margin-bottom: 12px;
    `,
};
